module.exports = __webpack_public_path__ + "img/banner-MG.9ac16ea6.png";